import http from './api';

const getBusinessProcesses = () => http.get('api/business-process');

export default { getBusinessProcesses };
